module.exports = __webpack_public_path__ + "static/media/arrow-right-full.43eea706.svg";